/**
 * Standing hint for third-party iOS browsers whose OS-level camera
 * permission may be off.
 *
 * When iOS denies camera access to the browser app itself, the native
 * file picker's camera opens as a black rectangle. The page cannot detect
 * this: the picker is presented by the host app, and WebKit implements
 * neither a camera entry in the Permissions API nor any signal back from
 * the picker. So the hint is unconditional rather than reactive - shown
 * to everyone on a non-Safari iOS browser, named to that browser.
 *
 * Safari is excluded (its camera access is not separately revocable as a
 * third-party app would be), as are in-app WKWebViews, which get the
 * louder InAppBrowserWarning banner instead.
 */

import { iosBrowserName, iosMajorVersion } from "./ios";

// Settings gained a dedicated "Apps" submenu in iOS 18; before that,
// app entries sit at the top level of Settings.
const SETTINGS_APPS_SUBMENU_SINCE = 18;

const CameraPermissionHint = {
  mounted() {
    const browser = iosBrowserName();
    if (!browser) return;

    const version = iosMajorVersion();
    const variant =
      version === null
        ? "fallback"
        : version >= SETTINGS_APPS_SUBMENU_SINCE
          ? "modern"
          : "legacy";

    const span = this.el.querySelector(`[data-ios-${variant}]`);
    if (!span) return;

    span.textContent = span.textContent.replaceAll("__BROWSER__", browser);
    span.classList.remove("hidden");
    this.el.classList.remove("hidden");
  },
};

export default CameraPermissionHint;
